const swiperHero = new Swiper(".swiper-hero", {
  // Optional parameters
  loop: false,
  autoHeight: true,
  slidesPerView: 1,
  slidesPerGroup: 1,

  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".hero-next",
    prevEl: ".hero-prev",
  },
});
